new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        getInfo(event, id) {
            axios.get(`/api/front/product/${id}/get-linked-product/`)
                .then(res => {
                    const actualElement = event.target;
                    if ($('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').length) {
                        $('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').remove();
                    }
                    actualElement.closest('.product-item-kit').setAttribute('data-product-item-kit-id', res.data.id);
                    actualElement.closest('.product-item-kit').querySelector('.is-selected').classList.remove('is-selected');
                    actualElement.closest('.product__colors-item').classList.add('is-selected');
                    actualElement.closest('.product-item-kit').querySelector('.name span').innerHTML = `${res.data.name}`;
                    actualElement.closest('.product-item-kit').querySelector('.name img').src = `${res.data.thumbnail}`;
                    const actualVariations = actualElement.closest('.product-item-kit').nextElementSibling;
                    actualVariations.innerHTML = '<p class="label_attributes">Selecione o tamanho</p>';
                    var sizes = [];
                    for (i = 0; i <= res.data.variations.length - 1; i++) {
                        if (res.data.variations[i].main_attribute != null) {
                            sizes.splice(res.data.variations[i].main_attribute.order, 0, res.data.variations[i]);
                        }
                    }
                    for (i = 0; i <= sizes.length - 1; i++) {
                        if (sizes[i].main_attribute != null) {
                            var randomNumber = Math.floor(Math.random() * 99999999);
                            var stock = sizes[i].available == false ? 'out-of-stock' : '';
                            actualVariations.insertAdjacentHTML('beforeend', `<input type="radio" name="product_item_variation__product_detail_{{ auto_id|unlocalize }}_${res.data.id}_${randomNumber}" id="product_item_variation__product_detail_{{ auto_id|unlocalize }}_${sizes[i].id}_${randomNumber}" value="${sizes[i].id}" data-id-auto="{{ auto_id|unlocalize }}" data-variation-name="${sizes[i].main_attribute.name}" data-origin-location="product_detail"><label for="product_item_variation__product_detail_{{ auto_id|unlocalize }}_${sizes[i].id}_${randomNumber}" class="label_radio ${stock} radio"><span>${sizes[i].main_attribute.value}</span></label>`);
                        }
                    }
                    if (res.data.addons.length) {
                        var complements = document.createElement('div');
                        complements.setAttribute('id', 'js-product_addons__product_detail_{{ auto_id|unlocalize }}');
                        complements.setAttribute('class', 'complements');
                        complements.setAttribute('complements-for', '{{ p.id }}');
                        complements.innerHTML = '<h2 class="complements-title">Complementos:</h2><br>';
                        for (i = 0; i <= res.data.addons.length - 1; i++) {
                            var optional = res.data.addons[i].is_required == false ? 'True' : 'False';
                            var addonPrice = res.data.addons[i].price ? res.data.addons[i].price : '';
                            complements.insertAdjacentHTML('beforeend', `<label class="complements-label-${res.data.addons[i].id}" addon-id="${res.data.addons[i].id}" addon-price="${addonPrice}" for="addon-${res.data.addons[i].id}" data-addon-is-optional="${optional}">${res.data.addons[i].field_label}</label>`);
                            if (res.data.addons[i].field_type == "radio_options") {
                                var complementsSelect = document.createElement('select');
                                complementsSelect.setAttribute('name', `addon-${res.data.addons[i].id}`);
                                complementsSelect.setAttribute('id', `addon-select-${res.data.addons[i].id}`);
                                for (j = 0; j <= res.data.addons[i].field_options.length - 1; j++) {
                                    complementsSelect.add(new Option(`${res.data.addons[i].field_options[j]}`, `${res.data.addons[i].field_options[j]}`));
                                }
                                var selectDiv = document.createElement('div');
                                selectDiv.setAttribute('class', 'complements-content');
                                $(selectDiv).append(complementsSelect);
                                $(complements).append(selectDiv);
                            } else if (res.data.addons[i].field_type == "text") {
                                var selectDiv = document.createElement('div');
                                selectDiv.setAttribute('class', 'complements-content-area');
                                $(selectDiv).append(`<input name="addon-${res.data.addons[i].id}" type="${res.data.addons[i].field_type}" maxlength="${res.data.addons[i].field_char_limit}"></div>`);
                                $(complements).append(selectDiv);
                            }
                        }
                        $('.kitcolors').closest('.itens-for-carousel').append(complements);
                    }
                    $('.kitcolors').height($('.kitcolors').closest('.itens-for-carousel').outerHeight());
                    $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').on('change', function () {
                        $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').not(this).prop('checked', false);
                    });
                    if (window.outerWidth <= 991) {
                        var slickSlider = $('.product-detail__header--photoArea-mobile');

                        if (slickSlider.hasClass('slick-initialized')) {
                            slickSlider.slick('slickRemove', null, null, true);
                        } else {
                            slickSlider.slick();
                        }

                        for (i = 0; i < res.data.images.length; i++) {
                            slickSlider.slick('slickAdd', `<li><a href="${res.data.images[i]}" data-fancybox="gallery3"><img class="product-detail__header--photoArea-mobile-img" src="${res.data.images[i]}" width="100%"></a></li>`);
                        }

                        slickSlider.slick('slickGoTo', 1);
                    } else {
                        const noThumbs = document.querySelector('#product-photo');
                        if (noThumbs) {
                            var noThumbsUl = document.querySelector('#product-photo ul');

                            // Remova todos os spans dentro do noThumbsUl
                            while (noThumbsUl.firstChild) {
                                noThumbsUl.removeChild(noThumbsUl.firstChild);
                            }

                            for (i = 0; i <= res.data.images.length - 1; i++) {
                                var li = document.createElement('li');
                                li.innerHTML = `<a href="${res.data.images[i]}" data-fancybox="gallery1"><img src="${res.data.images[i]}" width="100%"></a>`;
                                noThumbsUl.appendChild(li);
                            }
                        } else {
                            $('.sp-wrap').each(function () {
                                $(this).closest('.slick-slide').remove();
                            });
                            for (i = 0; i <= res.data.images.length - 1; i++) {
                                $('.sp-thumbs').slick('slickAdd', `<div><a class="sp-wrap" href="${res.data.images[i]}" style="background-image: url(${res.data.images[i]}); width: 100%; display: inline-block;" tabindex="0" data-video="undefined"><img src="${res.data.images[i]}" width="100%"></a></div>`, i);
                                if (i == 0) {
                                    document.querySelector('.sp-wrap').click();
                                }
                            }
                        }
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            let galleryLeft = document.querySelector('.gallery-left');
            let galleryRight = document.querySelector('.gallery-righ');

            if (photoArea && photoThumbs) {
                let photoListItem = document.querySelectorAll('#photo-list li');
                let singlePhotoItem = document.querySelectorAll('#product-photo img');

                if (photoListItem.length && singlePhotoItem.length) {
                    photoListItem[0].classList.add('active');
                    singlePhotoItem[0].classList.add('active');

                    function activeTab(index) {
                        singlePhotoItem.forEach((content) => {
                            content.classList.remove('active');
                        });
                        singlePhotoItem[index].classList.add('active');
                    }

                    photoListItem.forEach((itemMenu, index) => {
                        itemMenu.addEventListener('click', () => {
                            activeTab(index);
                        });
                    });
                }
            }

            if (galleryLeft && galleryRight) {
                $('#photo-list').slick({
                    infinite: false,
                    slidesToShow: 5,
                    vertical: true,
                    slidesToScroll: 1
                });
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        this.clickThumbs();

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const AttributesLabel = document.querySelector('.product-radio-variation .label_attributes');
        const groupLabel = document.querySelector('.group-label .label_attributes');
        if(AttributesLabel && groupLabel) {
            let textAttributes = AttributesLabel.textContent;
            groupLabel.textContent = textAttributes
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
    watch: {
        showOpened(newValue) {
            if (newValue) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.removeProperty('overflow');
            }
        },
    }
})

$(document).ready(function () {

    if (document.querySelector(".carousel-kit")) {
        var splide = new Splide('.carousel-kit', {
            type: "slide",
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            height: "auto",
            pagination: false,
            breakpoints: {
                768: {
                    drag: false,
                },
            },
        });

        splide.on('mounted', function () {
            var totalSlides = splide.length;
            var nextButton = document.querySelector('.carousel-kit-next');
            nextButton.setAttribute('data-end', totalSlides - 1);

            var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
            addToCartButton.classList.add('no-buy');

            var countDisplay = document.querySelector('.carousel-count');
            countDisplay.textContent = '1/' + totalSlides;
        });

        splide.mount();

        var nextButton = document.querySelector('.carousel-kit-next');
        var prevButton = document.querySelector('.carousel-kit-prev');
        var message = document.querySelector('.carousel-message');
        var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
        var countDisplay = document.querySelector('.carousel-count');

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {
                var activeSlide = document.querySelector('.splide__slide.is-active');
                var radioChecked = activeSlide.querySelector('.product-radio-variation input[type="radio"]:checked');
                var noVariations = activeSlide.querySelector('.js_product_item_kit').getAttribute('data-no-variations');

                if (radioChecked || noVariations) {
                    splide.go('>');
                    actual = Math.min(actual + 1, end);
                    nextButton.setAttribute('data-actual', actual);
                    message.classList.remove('show');
                    if (actual === end) {
                        addToCartButton.classList.remove('no-buy');
                        nextButton.classList.add('no-click');
                    }
                } else {
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                if (actual === end) {
                    nextButton.classList.remove('no-click');
                }
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
        });
    }

    const shareIcon = document.querySelector('.share-icon');
    const shareDetail = document.querySelector('.share__detail');
    if (shareIcon && shareDetail) {
        shareIcon.addEventListener('click', () => {
            shareDetail.classList.toggle('active');
            shareIcon.classList.toggle('active');
        });

        document.addEventListener('click', (event) => {
            // Verifica se o clique ocorreu fora do shareIcon e do shareDetail
            if (!shareIcon.contains(event.target) && !shareDetail.contains(event.target)) {
                shareDetail.classList.remove('active');
                shareIcon.classList.remove('active');
            }
        });
    }

    const headers = document.querySelectorAll('.product-detail__header--infoArea-description-tab h2');
    const descriptions = document.querySelectorAll('.description');
    if (headers.length && descriptions.length) {
        headers[0].classList.add('active');
        descriptions[0].classList.add('active');

        headers.forEach(header => {
            header.addEventListener('click', () => {
                headers.forEach(h => h.classList.remove('active'));
                descriptions.forEach(description => description.classList.remove('active'));

                header.classList.add('active');

                const index = header.getAttribute('data-index');

                const activeDescription = document.querySelector(`.description[data-index="${index}"]`);
                activeDescription.classList.add('active');
            });
        });
    }

    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
    })

    $('#like-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    })

    $('#product-detail-related-carrousel').slick({
        arrows: true,
        dots: true,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToScroll: 4,
                    slidesToShow: 4,
                }
            }
        ]
    });

    $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function (element) {
                setTimeout(function () {
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                }, 200);
            }
        });
    });

    $('#photo-fancy').fancybox();

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });
    }

	// Ajusta a altura do infoArea somando photoArea e yt-description (>=992px)
	function updateInfoAreaHeight() {
		const isDesktop = window.matchMedia('(min-width: 992px)').matches;
		const infoArea = document.querySelector('.product-detail__header--infoArea');
		if (!infoArea) return;
		const hasDescTab = infoArea.querySelector('.product-detail__header--infoArea-description-tab');
		const ytDescription = document.querySelector('.yt-description');
		const photoArea = document.querySelector('.product-detail__header--photoArea');

		if (isDesktop && ytDescription && hasDescTab && photoArea) {
			const photoHeight = photoArea.getBoundingClientRect().height;
			const ytHeight = ytDescription.getBoundingClientRect().height;
			const total = Math.round(photoHeight + ytHeight) + 20;
			infoArea.style.height = total + 'px';
		} else {
			infoArea.style.removeProperty('height');
		}
	}

	// Debounce para resize
	let resizeTimeout;
	window.addEventListener('resize', function () {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(updateInfoAreaHeight, 150);
	}, { passive: true });

	// Atualiza na carga do DOM e após imagens carregarem
	updateInfoAreaHeight();
	window.addEventListener('load', updateInfoAreaHeight, { passive: true });

	// Abre em modal (Fancybox) os links de vídeo que o cliente cadastra dentro do
	// valor dos atributos. O data-fancybox vazio faz o Fancybox abrir somente o
	// item clicado, sem agrupar os links dos outros atributos na mesma galeria.
	const VIDEO_HOSTS = /^(www\.|m\.)?(youtube\.com|youtu\.be|youtube-nocookie\.com|vimeo\.com|player\.vimeo\.com)$/;

	function isVideoLink(link) {
		try {
			return VIDEO_HOSTS.test(new URL(link.href, window.location.origin).hostname);
		} catch (e) {
			return false;
		}
	}

	function markAttributeVideoLinks() {
		document.querySelectorAll('.attribute-container a[href]').forEach(function (link) {
			if (link.hasAttribute('data-fancybox') || !isVideoLink(link)) return;

			link.setAttribute('data-fancybox', '');
			link.removeAttribute('target');
			link.classList.add('attribute-video-link');
		});
	}

	markAttributeVideoLinks();

	// Os atributos podem ser re-renderizados na troca de variação.
	const attributeContainers = document.querySelectorAll('.attribute-container');
	if (attributeContainers.length) {
		const attributeObserver = new MutationObserver(markAttributeVideoLinks);
		attributeContainers.forEach(function (container) {
			attributeObserver.observe(container, { childList: true, subtree: true });
		});
	}

});